if (!customElements.get('full-image-with-text')) {
  class FullImageWithText extends HTMLElement {
    variantChangedUnsubscriber = undefined;

    connectedCallback() {
      this.variantChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const {
          variant: { id },
        } = event.data;
        const url = `${this.productUrl}?section_id=${this.sectionId}${id ? `&variant=${id}` : ''}`;
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const source = html.getElementById(`shopify-section-${this.sectionId}`);

            if (source) {
              this.innerHTML = source.innerHTML;
            }
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              alert('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      });
    }

    disconnectedCallback() {
      if (this.variantChangedUnsubscriber) {
        this.variantChangedUnsubscriber();
      }
    }

    /**
     * Gets the section ID from the dataset.
     *
     * @returns {string} The section ID.
     */
    get sectionId() {
      return this.dataset.sectionId;
    }

    /**
     * Gets the URL of the product.
     *
     * @returns {string} The URL of the product.
     */
    get productUrl() {
      return this.dataset.productUrl;
    }
  }
  customElements.define('full-image-with-text', FullImageWithText);
}
